import { authRoles } from '@/core'
import { RouteRecordRaw } from 'vue-router'

const { ADMIN, ESTIMATOR, SELLER } = authRoles

const BusinessIntelligence = () =>
  import(/* webpackChunkName: "login-view" */ './views/pages/index.vue')

export const businessIntelligenceModuleRoutes: Array<RouteRecordRaw> = [
  {
    path: '/business-intelligence',
    name: 'business-intelligence',
    component: BusinessIntelligence,
    meta: {
      title: 'BI',
      auth: {
        roles: [ADMIN, ESTIMATOR, SELLER],
        redirect: '/auth/login',
        notFoundRedirect: { name: '/404' },
        forbiddenRedirect: '/404',
      },
    },
  },
]
